// extracted by mini-css-extract-plugin
export var childrenContainer = "_cx-0";
export var virtualScrollArea = "_cx-1";